// extracted by mini-css-extract-plugin
export default {"backgroundVideo":"BackgroundVideo_backgroundVideo__+YeeS","video":"BackgroundVideo_video__CMi+q"};